import * as z from 'zod';

const ENVS_VALIDOS = [
  'development',
  'homologation',
  'production',
  'testing',
] as const;

const PAGINAS_VALIDAS = [
  'registros',
  'atendimento',
  'atendimento.whatsapp',
  'relatorios',
  'clientes',
  'clientes.alterar-dados',
  'precos',
  'treinamentos',
] as const;

export type Pagina = (typeof PAGINAS_VALIDAS)[number];

const regraPaginaSchema = z.object({
  revendas: z.array(z.int()).optional(),
  emails: z.array(z.string()).optional(),
});

export type RegraPagina = z.infer<typeof regraPaginaSchema>;

const paginasSchema = z
  .string()
  .optional()
  .transform((raw, ctx) => {
    if (!raw) {
      return {};
    }

    try {
      return JSON.parse(raw) as unknown;
    } catch {
      ctx.addIssue({ code: 'custom', message: 'JSON inválido' });
      return z.NEVER;
    }
  })
  .pipe(
    z.partialRecord(
      z.enum(PAGINAS_VALIDAS),
      z.union([z.boolean(), regraPaginaSchema]),
    ),
  );

const envSchema = z.object({
  VITE_API_URL: z.url(),
  VITE_OLD_SITE_REDIRECT_URL: z.url(),
  VITE_API_AUTENTICACAO_URL: z.url(),
  VITE_TURNSTILE_SITE_KEY: z.string().default('1x00000000000000000000AA'),
  VITE_ANTIBOT_ENABLED: z.stringbool().catch(false),
  VITE_ENV: z.enum(ENVS_VALIDOS).default('production'),
  VITE_PDF_PASSO_A_PASSO_URL: z.url(),
  VITE_SITE_SECULLUM_URL: z.url(),
  VITE_SITE_SECULLUM_CAMINHO_RH: z.string(),
  VITE_EMAIL_LGPD: z.email().optional(),
  VITE_TOUR_TESTE_GRATIS_URL: z.url().optional(),
  VITE_REDIRECT_URL_SUCESSO_TESTE_GRATIS: z.url().optional(),
  VITE_EMAIL_TREINAMENTO: z.email().optional(),
  VITE_PAGINAS: paginasSchema,
  VITE_SAIBA_MAIS_SOBRE_PLANO_ULTIMATE_URL: z.url().optional(),
  VITE_RASTREIO_ENABLED: z.stringbool().catch(false),
  VITE_GOOGLE_TAG_MANAGER_ID: z.string().optional(),
  VITE_LINKEDIN_PARTNER_ID: z.string().optional(),
  VITE_LINKEDIN_CONVERSAO_TESTE_GRATIS_ID: z.coerce.number().int().optional(),
  VITE_NUMERO_WHATSAPP_ATENDIMENTO: z.string(),
  VITE_SITE_SECULLUM_CAMINHO_PERGUNTAS_FREQUENTES: z.string(),
  VITE_URL_COMUNIDADE_WHATSAPP: z.url(),
  VITE_URL_RECEITA_CONSULTA_CNPJ: z.url(),
  VITE_URL_RECEITA_CONSULTA_CPF: z.url(),
});

export default envSchema;
export type Env = z.infer<typeof envSchema>;
